import React, { useState, useEffect } from "react";
import FormInput from "../FormInput/FormInput";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import {
  createContactForm,
  clearErrors,
} from "../../redux/actions/contactFormActions";
import Loader from "../Loader/Loader";
import { Notification, EmptyingAllInputs } from "../../utils/";
const Form = () => {
  const { error, loading, response, success } = useSelector(
    (state) => state.contactForm
  );
  const dispatch = useDispatch();
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    phoneNumber: "",
    email: "",
    message: "",
  });

  const contactSchema = yup.object().shape({
    firstName: yup.string().required("First name is required"),
    lastName: yup.string().required("Last name is required"),
    phoneNumber: yup
      .string()
      .min(10, "Please Enter a valid Phone Number")
      .required("Phone number is required"),
    email: yup
      .string()
      .email("Field should contain a valid e-mail")
      .max(255)
      .required("E-mail is required"),
    message: yup.string().required("Message is required"),
  });

  const {
    register,
    setValue,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(contactSchema),
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({
      ...form,
      [name]: value,
    });
    setValue(name, value, { shouldValidate: true });
  };

  const onSubmit = (data) => {

    dispatch(createContactForm(data));
    reset();
    EmptyingAllInputs();
    
  };

  useEffect(() => {
    Notification(success, error, response);
    dispatch(clearErrors());
  }, [dispatch, error, loading, response, success]);

  return (
    <div className="contact-form-wrap">
      <form id="contact-form" onSubmit={handleSubmit(onSubmit)}>
        <div className="row">
          <div className="col-md-6">
            <FormInput
              tag={"input"}
              type={"text"}
              name={"firstName"}
              placeholder={"First Name *"}
              onChange={handleChange}
              error={errors["firstName"]}
              register={register}
            />
          </div>

          <div className="col-md-6">
            <FormInput
              tag={"input"}
              type={"text"}
              name={"lastName"}
              placeholder={"Last Name *"}
              onChange={handleChange}
              error={errors["lastName"]}
              register={register}
            />
          </div>

          <div className="col-md-6">
            <FormInput
              tag={"input"}
              type={"email"}
              name={"email"}
              placeholder={"Email address *"}
              onChange={handleChange}
              error={errors["email"]}
              register={register}
            />
          </div>

          <div className="col-md-6">
            <FormInput
              tag={"input"}
              type={"text"}
              name={"phoneNumber"}
              placeholder={"Phone No"}
              onChange={handleChange}
              error={errors["phoneNumber"]}
              register={register}
            />
          </div>

          <div className="col-12">
            <FormInput
              tag={"textarea"}
              name={"message"}
              placeholder={"Write Your Message *"}
              onChange={handleChange}
              error={errors["message"]}
              register={register}
            />

            <div className="contact-btn">
              <button type="submit">
                {loading ? <Loader /> : "Submit"}

                <span className="ti-arrow-right" />
              </button>
            </div>

            <div className="form-message" />
          </div>
        </div>
      </form>
    </div>
  );
};

export default Form;
